"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nanto": {
    "513bc754": [{
      "hkey": "d57a8b25",
      "slug": "nanto",
      "name": "Nanto",
      "primary": true,
      "skipSearch": false
    }],
    "brazzolaro": [{
      "hkey": "d57a8b25",
      "slug": "nanto",
      "name": "Nanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1049de2d": [{
      "hkey": "d57a8b25",
      "slug": "nanto",
      "name": "Nanto",
      "primary": true,
      "skipSearch": false
    }],
    "monti-di-nanto": [{
      "hkey": "d57a8b25",
      "slug": "nanto",
      "name": "Nanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;